var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"bg-white fill-width fill-height rounded",attrs:{"id":"historyLogs"}})
}
var staticRenderFns = []

export { render, staticRenderFns }